import { styles as stylesModal } from "../../../../components/single-registry/modals/TemplateDownloadModal/TemplateDownloadModal.styles";

export const styles = {
  ...stylesModal,
  titleText: {
    ...stylesModal.titleText,
    fontSize: "16px",
    fontWeight: 400,
  },
  subtitle: {
    ...stylesModal.subtitle,
    fontWeight: 500,
    lineHeight: "24px",
  },
};
